<template>
  <div class="user-wrapper">
    <!-- 隐藏帮助链接 -->
    <a v-if="false" href="https://pro.loacg.com/docs/getting-started" target="_blank">
      <span class="action">
        <a-icon type="question-circle-o"></a-icon>
      </span>
    </a>
    <!-- 隐藏通知提示 -->
    <header-notice v-if="false" class="action"/>
    <a-dropdown>
      <span class="action ant-dropdown-link user-dropdown-menu">
        <!-- <a-avatar class="avatar" size="small" :src="avatar()"/> -->
        <a-avatar class="avatar" style="color: #f56a00; backgroundColor: #fde3cf">{{ avatarName }}</a-avatar>
        <span>{{ nickname() }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
        <a-menu-item key="1">
          <router-link :to="{ name: 'settings' }">
            <a-icon type="setting"/>
            <span>Account Settings</span>
          </router-link>
        </a-menu-item>
        <a-menu-divider/>
        <a-menu-item key="3">
          <a href="javascript:;" @click="handleLogout">
            <a-icon type="logout"/>
            <span>Log Out</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import HeaderNotice from './HeaderNotice'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserMenu',
  components: {
    HeaderNotice
  },
  data () {
    return {
      userinfo: null,
      avatarName: null
    }
  },
  created () {
    this.user = this.userInfo
    const avatarName = this.user.userName.substr(0, 1).toUpperCase()
    this.avatarName = avatarName
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar']),
    handleLogout () {
      const that = this

      this.$confirm({
        title: 'Tips',
        content: 'Do you really want to log out?',
        onOk () {
          return that.Logout({}).then(() => {
            window.location.reload()
          }).catch(err => {
            that.$message.error({
              title: 'Error',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
